import React, { useState } from 'react';

const Testimonials = () => {
  const [selectedStory, setSelectedStory] = useState(null);

  const stories = [
    {
      id: 1,
      name: 'Ashwini S',
      university: 'MAHE',
      program: 'Online MBA',
      quote:
        'Being a working professional, having flexibility in terms of online classes and exams was of utmost importance to me. I wanted to upskill without quitting my job and this online MBA from MAHE happened to be the best option. Also, Manipal has a great brand value.',
      fullQuote:
        'Being a working professional, having flexibility in terms of online classes and exams was of utmost importance to me. I wanted to upskill without quitting my job and this online MBA from MAHE happened to be the best option. Also, Manipal has a great brand value and the faculty guidance throughout the semesters was top notch.',
      role: 'Working Professional'
    },
    {
      id: 2,
      name: 'Dishani Chakraborty',
      university: 'MUJ',
      program: 'Online MBA',
      quote:
        'The interactive weekend live sessions and peer networking allowed me to collaborate with industry professionals across India while balancing my full-time work commitments.',
      fullQuote:
        'The interactive weekend live sessions and peer networking allowed me to collaborate with industry professionals across India while balancing my full-time work commitments. Online Manipal exceeded my expectations with its rich digital library and career placement drives.',
      isVideo: true,
      role: 'Management Trainee'
    },
    {
      id: 3,
      name: 'Rajat Kumar',
      university: 'MUJ',
      program: 'Online MBA (Batch 1)',
      quote:
        'Currently employed with Aditya Birla Group, after a break of 10 years from academics, I chose to pursue an online MBA to acquire practical skills that contribute directly to my job role.',
      fullQuote:
        'Currently employed with the Aditya Birla Group, after a break of 10 years from academics, I chose to pursue an online MBA to acquire practical skills that will help contribute to my current job role. By interacting with peers from diverse professional backgrounds, this program has not only equipped me with valuable skills but has also expanded my professional network.',
      role: 'Aditya Birla Group'
    },
    {
      id: 4,
      name: 'Syeda Hijab Fatima',
      university: 'MUJ',
      program: 'Online MBA (Batch 9)',
      quote:
        'Choosing to pursue my MBA in Online Manipal at MUJ was an easy choice for me. The weekend classes and recorded sessions help me manage both personal life and education in one go.',
      fullQuote:
        'Choosing to pursue my MBA in Online Manipal at MUJ was an easy choice for me because I had also completed my BBA from here. During the orientation, the faculty interaction, the course structure, and the energy in the air was so lovely that all my doubts vanished.',
      role: 'Graduate Student'
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <h2 className="section-title">
            Real Stories, <span>Real Impact</span>
          </h2>
          <p className="section-subtitle">
            Discover how Online Manipal MBA degrees transformed careers for working professionals
          </p>
        </div>

        <div className="stories-grid">
          {stories.map((story) => (
            <div className="story-card" key={story.id}>
              <div className="story-header">
                <div className="story-avatar">{story.name.charAt(0)}</div>
                <div className="story-author-info">
                  <h4 className="author-name">{story.name}</h4>
                  <span className="author-details">
                    {story.program} • <strong>{story.university}</strong>
                  </span>
                  <span className="author-role">{story.role}</span>
                </div>
              </div>

              <div className="story-body">
                <p className="story-quote">"{story.quote}"</p>
              </div>

              <div className="story-footer">
                <button
                  className="btn-read-more"
                  onClick={() => setSelectedStory(story)}
                >
                  Read Full Story →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Story Popup Modal */}
      {selectedStory && (
        <div className="modal-overlay" onClick={() => setSelectedStory(null)}>
          <div className="modal-content story-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedStory(null)}>
              ×
            </button>
            <div className="story-modal-header">
              <div className="story-avatar large">{selectedStory.name.charAt(0)}</div>
              <div>
                <h3>{selectedStory.name}</h3>
                <p className="story-meta">
                  {selectedStory.program} • {selectedStory.university} ({selectedStory.role})
                </p>
              </div>
            </div>
            <div className="story-modal-body">
              <p>{selectedStory.fullQuote}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
